<template>
  <v-dialog
    width="600"
    v-model="opened"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
    persistent
    lazy
  >
    <v-card>
      <v-card-title class="title pb-1">Signature</v-card-title>

      <v-tabs fixed-tabs v-model="active">
        <v-tab :disabled="forceTypeSignature" class="text-capitalize"
          >Draw</v-tab
        >
        <v-tab class="text-capitalize" :disabled="forceDrawSignature"
          >Type</v-tab
        >
      </v-tabs>

      <v-tabs-items v-model="active">
        <v-tab-item>
          <v-layout row justify-center class="signature-pad-container">
            <VueSignaturePad
              class="signature-pad"
              width="300px"
              height="100px"
              ref="signaturePadRef"
              :options="options"
            />
          </v-layout>
        </v-tab-item>

        <v-tab-item>
          <v-layout row justify-center>
            <v-text-field
              class="signature"
              :value="textSignature"
              ref="signatureInputRef"
              placeholder="Type signature here"
              @input="$emit('update:textSignature', $event)"
            />
          </v-layout>
        </v-tab-item>
      </v-tabs-items>

      <v-card-actions>
        <v-btn
          outline
          class="primary--text text-none"
          @click="clearSignature()"
          v-if="active === 0"
        >
          Clear
        </v-btn>
        <v-spacer />
        <v-btn
          :disabled="!canSave"
          :loading="saving"
          class="primary text-none"
          @click="saveSignature()"
        >
          Sign
        </v-btn>
        <v-btn
          class="error--text text-none"
          flat
          @click="$emit('update:opened', false)"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import FirmPreferenceMixins from '@/mixins/FirmPreferenceMixins';

export default {
  name: 'signturePadDialog',

  props: {
    opened: {
      type: Boolean,
    },

    saving: {
      type: Boolean,
    },

    signatureType: {
      type: String,
    },

    imageSignature: {
      type: String,
    },

    textSignature: {
      type: String,
    },
  },

  mixins: [FirmPreferenceMixins],

  data() {
    return {
      active: this.signatureType === 'image' ? 0 : 1,
      options: {
        penColor: '#000',
        onEnd: this.setImageSignature,
      },
    };
  },

  methods: {
    clearSignature() {
      this.$refs.signaturePadRef.clearSignature();
      this.$emit('update:imageSignature', '');
    },

    saveSignature() {
      if (this.active === 0 && !this.forceTypeSignature) {
        this.$emit('update:signatureType', 'image');
        this.$emit('saveSignature');
      } else {
        this.$emit('update:signatureType', 'text');
        this.$emit('saveSignature');
      }
    },

    setImageSignature() {
      const { data } = this.$refs.signaturePadRef.saveSignature();
      this.$emit('update:imageSignature', data);
    },
  },

  computed: {
    canSave() {
      if (this.active === 0 && !isEmpty(this.imageSignature)) {
        return true;
      } else if (this.active === 1 && !isEmpty(this.textSignature)) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    active: {
      handler(value) {
        if (value === 1) {
          this.$refs.signatureInputRef.focus();
        }
        this.$emit('update:signatureType', value === 0 ? 'image' : 'text');
      },
    },

    imageSignature: {
      handler(value) {
        if (isEmpty(value)) {
          this.clearSignature();
        } else {
          this.$refs.signaturePadRef.fromDataURL(value);
        }
      },
    },

    signatureType: {
      handler(value) {
        if (value === 'image') {
          this.active = 0;
        } else {
          this.active = 1;
        }
      },
    },
  },

  mounted() {
    if (this.$refs.signaturePadRef) {
      this.$refs.signaturePadRef.fromDataURL(this.imageSignature);
    }
    if (this.forceTypeSignature) {
      this.active = 1;
    }
  },
};
</script>

<style lang="postcss" scoped>
.signature-pad-container {
  background: #eee;
  padding: 20px;
}
.signature-pad {
  background: #fff;
}
.signature {
  font-family: 'Zeyada', cursive;
  font-size: 32px;
  max-width: 300px;

  & >>> input {
    max-height: 50px;
    text-align: center;
  }
}
</style>
